"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf3 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _clipboardPolyfill = _interopRequireDefault(require("clipboard-polyfill"));

var _classnames = _interopRequireDefault(require("classnames"));

var _react = _interopRequireDefault(require("react"));

var _reactTippy = require("react-tippy");

var _Icon = _interopRequireDefault(require("./Icon"));

var CopyToClipboard = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2.default)(CopyToClipboard, _React$Component);

  function CopyToClipboard() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2.default)(this, CopyToClipboard);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2.default)(this, (_getPrototypeOf2 = (0, _getPrototypeOf3.default)(CopyToClipboard)).call.apply(_getPrototypeOf2, [this].concat(args)));
    _this.state = {
      copied: false
    };

    _this.copyToClipboard = /*#__PURE__*/function () {
      var _ref = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(event) {
        var content, element, clip;
        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                event.stopPropagation();
                event.preventDefault();
                content = _this.props.content;
                element = _this.contentElement; // For some reason, nothing to copy.

                if (!(!content || !element)) {
                  _context.next = 6;
                  break;
                }

                return _context.abrupt("return");

              case 6:
                _context.prev = 6;
                clip = new _clipboardPolyfill.default.DT();

                if (typeof content === 'string') {
                  clip.setData('text/plain', content);
                } else {
                  clip.setData('text/html', new XMLSerializer().serializeToString(element));
                }

                _context.next = 11;
                return _clipboardPolyfill.default.write(clip);

              case 11:
                _this.showFeedback();

                _context.next = 17;
                break;

              case 14:
                _context.prev = 14;
                _context.t0 = _context["catch"](6);
                console.log('! CopyToClipboard error', _context.t0);

              case 17:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[6, 14]]);
      }));

      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }();

    _this.showFeedback = function () {
      _this.setState({
        copied: true
      });
    };

    return _this;
  }

  (0, _createClass2.default)(CopyToClipboard, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      if (prevState.copied === true) {
        this.setState({
          copied: false
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          className = _this$props.className,
          style = _this$props.style;
      var _this$props2 = this.props,
          children = _this$props2.children,
          content = _this$props2.content,
          showLinkIcon = _this$props2.showLinkIcon,
          tooltip = _this$props2.tooltip;
      var copied = this.state.copied;

      if (!content) {
        return children;
      }

      var renderLinkIcon = function renderLinkIcon() {
        return _react.default.createElement(_Icon.default, {
          icon: "ios-link",
          key: "tooltip-icon",
          style: {
            position: 'relative',
            verticalAlign: 'text-top'
          }
        });
      };

      return _react.default.createElement("div", {
        className: (0, _classnames.default)((0, _defineProperty2.default)({
          'copy-to-clipboard relative inline-block cursor-pointer': true,
          'animated jello': copied
        }, className, className)),
        onClick: function onClick(event) {
          return _this2.copyToClipboard(event);
        },
        style: style
      }, _react.default.createElement("div", {
        style: {
          border: 0,
          bottom: -90,
          height: 0,
          left: -90,
          opacity: 0,
          outline: 0,
          overflow: 'hidden',
          padding: 0,
          position: 'fixed',
          width: 1,
          zIndex: '-999'
        }
      }, _react.default.createElement("div", {
        ref: function ref(element) {
          return _this2.contentElement = element;
        }
      }, content)), tooltip === false ? _react.default.createElement("div", {
        className: "inline-block"
      }, showLinkIcon && renderLinkIcon(), children) : _react.default.createElement(_reactTippy.Tooltip, {
        className: "tooltip",
        position: "top",
        title: typeof tooltip === 'string' ? tooltip : showLinkIcon ? 'Copy link to clipboard.' : 'Copy to clipboard.'
      }, showLinkIcon && renderLinkIcon(), children));
    }
  }]);
  return CopyToClipboard;
}(_react.default.Component);

CopyToClipboard.defaultProps = {
  showLinkIcon: false,
  tooltip: true
};
var _default = CopyToClipboard;
exports.default = _default;